import { useEffect, useState } from 'react';
import {
  elapsedSecondsSince,
  readRunningTimer,
  subscribeRunningTimer,
  type RunningTimerPayload,
} from '@/lib/running-timer-storage.js';

export function useRunningTimerClock() {
  const [payload, setPayload] = useState<RunningTimerPayload | null>(() =>
    typeof window === 'undefined' ? null : readRunningTimer(),
  );

  useEffect(() => {
    setPayload(readRunningTimer());
    return subscribeRunningTimer(() => setPayload(readRunningTimer()));
  }, []);

  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (!payload) return;
    const id = window.setInterval(() => setTick((n) => n + 1), 1000);
    return () => window.clearInterval(id);
  }, [payload]);

  void tick;

  const elapsed = payload ? elapsedSecondsSince(payload.startedAt) : 0;
  return { payload, elapsed };
}
